/**
 * Keep sync with `ryde-backend/libs/shared/src/enums/production/assign-docks-during-production.enum.ts`.
 * Values double as `selectListLabel.*` translation keys, so they must stay unique across all select lists —
 * hence `NoDocks` rather than a generic `None`.
 */
export enum AssignDocksDuringProductionEnum {
  NoDocks = "NoDocks",
  DropoffOnly = "DropoffOnly",
}
